import { Navigate } from "react-router-dom";
import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import { lazy } from "react";
import { Logout } from ".";
import BulkCampaignCreation from "../campaign-creation/BulkSmsCampaignCreation";
import SMSCampaignCreation from "../campaign-creation/BulkCampaigns";
import ContactList from "../Configurations/ContactList/contact-list";

const ViewCampaign = Loadable(lazy(() => import("../Reoprts/view-uses/campaign-uses-view")));
// const FlashCampaign = Loadable(lazy(() => import("../Reoprts/Flash-report")));
const Dashboard = Loadable(lazy(() => import("../Dashboard/index")));
const ChildUserList = Loadable(lazy(() => import("../Configurations/UserManagement/api-user-management/child-user-list")));
const UnauthorizedAccess = Loadable(lazy(() => import("../../utils/ui-components/UnauthorizedAccess")));
const CampaignReports = Loadable(lazy(() => import("../Reoprts/CampaignReport")));
const CampaignCreation = Loadable(lazy(() => import("../campaign-creation")));

function ParentAuthorizedRoutes(role: any) {
  return [
    {
      path: "/",
      element: <MainLayout role={role} />,
      children: [
        {
          path: "/",
          element: <Dashboard />,
        },
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "api-user",
          children: [
            {
              path: "list",
              element: <ChildUserList />,
            },
          ],
        },
        {
          path: "number-base",
          element: <ContactList role={role} />,
        },
        {
          path: "reports",
          children: [
            {
              path: "campaign-report",
              element: <CampaignReports />,
            },
            {
              path: "api-report/:campaigntype/:id",
              element: <ViewCampaign />,
            },
            {
              path: "flash-report/:campaigntype/:id",
              element: <ViewCampaign />,
            },
            {
              path: "bulk-sms-report/:campaigntype/:id",
              element: <ViewCampaign />,
            },
            {
              path: "pending-report/:campaigntype/:id",
              element: <ViewCampaign />,
            },
          ],
        },
        {
          path: "campaign-creation",
          children: [
            {
              path: "",
              element: <CampaignCreation role={role} />,
            },
            {
              path: "sms",
              element: <SMSCampaignCreation role={role} />,
            },
          ],
        },
        // {
        //   path: "campaign-creation",
        //   children: [
        //     {
        //       path: "",
        //       element: <BulkCampaignCreation role={role} />,
        //     },
        //   ],
        // },
      ],
    },
    {
      path: "unauthorized",
      element: <UnauthorizedAccess />,
    },
    {
      path: "",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "logout",
      element: <Logout />,
    },
    {
      path: "verify-login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "*",
      element: <Navigate to="/unauthorized" />,
    },
  ];
}

export default ParentAuthorizedRoutes;
